import { Modal as BSModal } from 'react-bootstrap';

import { useTrapFocus } from '../../hooks';

import '@consumer-bootstrap/components/modal.scss';
import '@consumer-bootstrap/index.scss';

export type ModalPropsT = {
  body: React.ReactNode;
  footer: React.ReactNode;
  onHide: () => void;
  show: boolean;
  title: string;
  backdrop?: 'static' | boolean;
  className?: string;
  closeButton?: boolean;
  keyboard?: boolean;
};
export type ModalT = React.FC<ModalPropsT>;

export const Modal: ModalT = ({
  body,
  closeButton = false,
  footer,
  show,
  title,
  ...props
}) => {
  const { modalWrapper } = useTrapFocus(show);

  return show && (
    <BSModal {...props} show>
      <div ref={modalWrapper}>
        <BSModal.Header closeButton={closeButton}>
          <BSModal.Title>{title}</BSModal.Title>
        </BSModal.Header>
        <hr className="modal-divider" />
        <BSModal.Body>{body}</BSModal.Body>
        <BSModal.Footer>{footer}</BSModal.Footer>
      </div>
    </BSModal>
  );
};
